module.exports = __webpack_public_path__ + "static/media/lean.ec7cf79d.jpg";